module.exports = __webpack_public_path__ + "static/media/exportables.fc65fd7d.svg";